/**
 * Easing curves for particle lifetime interpolation (TRD-04 R-04-05).
 *
 * Presentation only. `Math.random` and non-deterministic maths are not just permitted
 * here, they are expected — this code must never touch the simulation (R-04-01).
 */

export type EaseName = 'linear' | 'easeOutQuad' | 'easeOutCubic' | 'easeInQuad' | 'easeOutExpo';

export const EASE: Record<EaseName, (t: number) => number> = {
  linear: (t) => t,
  easeOutQuad: (t) => t * (2 - t),
  easeOutCubic: (t) => 1 - (1 - t) ** 3,
  easeInQuad: (t) => t * t,
  easeOutExpo: (t) => (t >= 1 ? 1 : 1 - 2 ** (-10 * t)),
};

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Channel-wise interpolation between two packed 0xRRGGBB colours. */
export function lerpColor(from: number, to: number, t: number): number {
  const fr = (from >> 16) & 0xff;
  const fg = (from >> 8) & 0xff;
  const fb = from & 0xff;
  const tr = (to >> 16) & 0xff;
  const tg = (to >> 8) & 0xff;
  const tb = to & 0xff;
  return (
    ((fr + (tr - fr) * t) << 16) | (((fg + (tg - fg) * t) | 0) << 8) | ((fb + (tb - fb) * t) | 0)
  );
}

export function randRange(min: number, max: number): number {
  return min + Math.random() * (max - min);
}
